import styled from 'styled-components';

import { ToggleMenu } from '@hero/components/molecules';

const MessageExperienceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  ${ToggleMenu.S.ToggleMenuContent} {
    background: var(--color-bg-default);
    overflow: overlay;
  }
`;

const ToggleMenuTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const OverviewWrapper = styled.div``;

const GreetingCardColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export { GreetingCardColumn, MessageExperienceWrapper, OverviewWrapper, ToggleMenuTitleWrapper };
